import React, { useState, createContext, useContext, useEffect } from "react";

const initialState = { theme: "light-theme" };

const ThemeContext = createContext(initialState);
const ThemeActionsContext = createContext();

const OrgLogoContext = createContext();
const OrgLogoActionsContext = createContext();

const SubDomainContext = createContext();
const SubDomainActionsContext = createContext();

export const useThemeContext = () => useContext(ThemeContext);
export const useThemeActionsContext = () => useContext(ThemeActionsContext);

export const useOrgLogoContext = () => useContext(OrgLogoContext);
export const useOrgLogoActionsContext = () => useContext(OrgLogoActionsContext);

export const useSubDomainContext = () => useContext(SubDomainContext);
export const useSubDomainActionsContext = () =>
  useContext(SubDomainActionsContext);

export const ThemeChangeProvider = ({ children }) => {
  const [theme, setTheme] = useState("");
  const [subDomain, setSubDomain] = useState(
    sessionStorage.getItem("subDomain")
  );

  const updateTheme = (selectedTheme) => {
    setTheme(selectedTheme);
  };

  const updateSubDomain = (name) => {
    setSubDomain(name);
  };

  return (
    <ThemeContext.Provider value={theme}>
      <ThemeActionsContext.Provider value={updateTheme}>
        <SubDomainContext.Provider value={subDomain}>
          <SubDomainActionsContext.Provider value={updateSubDomain}>
            {children}
          </SubDomainActionsContext.Provider>
        </SubDomainContext.Provider>
      </ThemeActionsContext.Provider>
    </ThemeContext.Provider>
  );
};
